const brand = {
    name: 'Pikachu',
    role: 'Creative developer',
    siteUrl: 'https://pikachu.com',
    social: {
        twitter: 'https://twitter.com/pikachu/',
        github: 'https://github.com/pikachu/',
        linkedin: 'https://www.linkedin.com/in/pikachu/',
        email: 'mailto:pikachu@gmail.com'
    },
    socialImage: {
        og: 'https://pikachu.com/social/share-1200x630.png',
        twitter: 'https://pikachu.com/social/share-1200x600.png'
    }
}

export default brand